<template>
    <div class="certificate-page">
        <!-- 顶部导航 -->
        <div class="page-header">
            <van-icon name="arrow-left" size="20" color="#333" @click="goBack" />
            <div class="header-title">证书查看</div>
            <div class="header-placeholder"></div>
        </div>

        <!-- 证书图片 -->
        <div class="certificate-container">
            <img 
                v-if="certificateUrl" 
                :src="certificateUrl" 
                alt="证书" 
                class="certificate-image"
                @load="onImageLoad"
                @error="onImageError"
            />
            <div v-else-if="loading" class="loading-state">
                <van-loading type="spinner" color="#00BCD4" size="40px">加载中...</van-loading>
            </div>
            <div v-else class="error-state">
                <van-icon name="warning-o" size="60" color="#ccc" />
                <div class="error-text">证书加载失败</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCertificate } from '@/api/index.js';

export default {
    name: 'Certificate',
    data() {
        return {
            certificateUrl: '',
            loading: true
        };
    },
    created() {
        this.loadCertificate();
    },
    methods: {
        goBack() {
            this.$router.back();
        },
        loadCertificate() {
            const answerId = this.$route.query.answerId;
            
            if (!answerId) {
                this.$toast('缺少答卷ID');
                this.loading = false;
                return;
            }
            
            this.loading = true;
            
            getCertificate(answerId).then(res => {
                this.loading = false;
                
                if (res.data) {
                    this.certificateUrl = res.data;
                } else {
                    this.$toast('获取证书失败');
                }
            }).catch(err => {
                this.loading = false;
                this.$toast('获取证书失败');
                console.error('获取证书失败:', err);
            });
        },
        onImageLoad() {
            // 图片加载成功
        },
        onImageError() {
            this.$toast('图片加载失败');
        }
    }
};
</script>

<style scoped lang='scss'>
.certificate-page {
    min-height: 100vh;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
}

.page-header {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 15px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    
    .header-title {
        font-size: 16px;
        color: #333;
        font-weight: 500;
    }
    
    .header-placeholder {
        width: 20px;
    }
    
    .van-icon {
        cursor: pointer;
        
        &:active {
            opacity: 0.7;
        }
    }
}

.certificate-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    min-height: calc(100vh - 50px);
}

.certificate-image {
    width: 100%;
    height: auto;
    display: block;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
}

.error-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    
    .error-text {
        margin-top: 16px;
        font-size: 14px;
        color: #999;
    }
}
</style>

